var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPifssLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 727.92 703.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "678.9 367.88 727.92 414.85 727.92 638.68 678.9 638.68 678.9 367.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "609.53 309.41 658.55 351.13 658.55 638.68 609.53 638.68 609.53 309.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "541.08 497.41 590.1 543.6 590.1 638.68 541.08 638.68 541.08 497.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "541.08 435.06 590.1 479.51 590.1 523.97 541.08 483.56 541.08 435.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "541.08 370.97 590.1 415.42 590.1 459.88 541.08 419.47 541.08 370.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "472.64 268.19 521.66 313.26 521.66 638.68 472.64 638.68 472.64 268.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "522.12 223.74 497.61 246.27 473.1 223.74 473.1 255.49 480.53 261.97 497.61 276.86 522.12 298.22 522.12 268.8 514.69 261.97 522.12 255.49 522.12 223.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "405.12 535.43 392.17 535.43 343.15 535.43 343.15 584.45 343.15 593.26 392.17 638.68 392.17 584.45 405.12 584.45 405.12 638.68 454.14 638.68 454.14 584.45 454.14 535.43 405.12 535.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "274.7 435.06 323.72 479.51 323.72 575.36 274.7 529.75 274.7 435.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "274.7 545.34 323.72 589.79 323.72 638.68 274.7 593.07 274.7 545.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "206.72 432.84 255.74 477.3 255.74 526.19 206.72 480.57 206.72 432.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 432.84 49.02 477.3 49.02 526.19 0 480.57 0 432.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 367.88 49.02 412.34 49.02 461.23 0 415.61 0 367.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "274.7 610 323.72 654.46 323.72 703.35 274.7 657.74 274.7 610"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "205.33 497.41 254.35 545.34 254.35 638.68 205.33 638.68 205.33 497.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "138.74 0 187.76 45.21 187.76 638.68 138.74 638.68 138.74 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "69.44 497.41 118.47 545.34 118.47 638.68 69.44 638.68 69.44 497.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 497.41 49.02 539.28 49.02 638.68 0 638.68 0 497.41"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPifssLogo);
export default __webpack_public_path__ + "static/media/pifss-logo.e3ad998128824b52568e068daa135022.svg";
export { ForwardRef as ReactComponent };